<template>
  <div>
    <div class="row">
      <div class="col-6">
        <div class="mx-4 d-flex flex-column">
          <h5 class="py-3">選擇圖片</h5>
          <el-select v-model="imageFileName" class="m-2" placeholder="Select" id="modeVertical">
            <el-option v-for="item in bgImages" :key="item.value" :label="item.label"
                       :value="item.value" />
          </el-select>
        </div>
        <div>
          <label class="me-3" for="color">背景色</label>
          <el-color-picker color-format="rgb" v-model="bgColor" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="mx-4">
          <h5 class="py-3">文字控制</h5>
          <div>
            <label class="me-3" for="textMode">選擇文字模式</label>
            <el-select v-model="textModeValue" class="m-2" id="textMode" @change="handleChangeTextMode">
              <el-option v-for="item in textModeIncludeDuo" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </div>
          <div v-if="textModeValue !== 'None' && textModeValue !== 'Custom'">
            <label class="me-3" for="fontFamilyMode">選擇字體</label>
            <el-select v-model="fontFamily" class="m-2" id="fontFamilyMode" >
              <el-option v-for="item in fontFamilyVerticalWithSensor" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </div>
          <div v-else-if="textModeValue !== 'None' && textModeValue === 'Custom'">
            <label class="me-3" for="fontFamilyMode">選擇字體</label>
            <el-select v-model="fontFamily" class="m-2" id="fontFamilyMode" >
              <el-option v-for="item in fontFamilyVertical" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </div>
        </div>
      </div>
      <template v-if="textModeValue === 'SliderSensor' || textModeValue === 'Time'">
        <div class="col-6" v-if="textModeValue === 'SliderSensor'">
          <div class="mx-4">
            <div class="me-3" >Controller選擇 (可複選)</div>
            <div class="d-flex flex-wrap">
              <div class="m-2" v-for="controller in showTextsList" :key="controller">
                <input class="me-1" type="checkbox" :id="controller" :value="controller"
                       v-model="controllerSelected" @change="limitCheckbox">
                <label class="fw-bold" :for="controller">{{ controller }}</label>
              </div>
            </div>
            <div class="m-2">
              <label class="fw-bold me-1" for="loopSecond">Loop Second</label>
              <input class="me-1" type="number" id="loopSecond"
                     v-model="controllerLoopSecond">
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="my-3">
            <label class="me-3" for="textBoxPositionHorizontal">選擇水平方向</label>
            <el-select v-model="horizontalValue" class="m-2" id="textBoxPositionHorizontal">
              <el-option v-for="item in textBoxPositionHorizontal" :key="item.value" :label="item.label"
                         :value="item.value" />
            </el-select>
          </div>
          <div class="my-3">
            <label class="me-3" for="textBoxPositionVertical">選擇垂直方向</label>
            <el-select v-model="verticalValue" class="m-2" id="textBoxPositionVertical">
              <el-option v-for="item in textBoxPositionVertical" :key="item.value" :label="item.label"
                         :value="item.value" />
            </el-select>
          </div>
          <div class="my-3">
            <label class="me-3" for="textBoxPositionVertical">選擇文字方向</label>
            <el-select v-model="textAlignmentValue" class="m-2" id="textBoxPositionVertical">
              <el-option v-for="item in textAlignments" :key="item.value" :label="item.label"
                         :value="item.value" />
            </el-select>
          </div>
          <div class="my-3">
            <label class="me-5">Label 顏色</label>
            <el-color-picker color-format="rgb" v-model="labelTextColor[0]" />
            <el-color-picker color-format="rgb" v-model="labelTextColor[1]" />
            <el-color-picker color-format="rgb" v-model="labelTextColor[2]" />
          </div>
        </div>
      </template>
      <template v-else-if="textModeValue === 'DuoSensor'">
        <div class="col-6" >
          <div class="mx-4">
            <div class="me-3" >Controller選擇 (擇2)</div>
            <el-select
                v-model="controllerSelected"
                class="m-2"
                id="showTextsListOptions"
                :multiple="true"
                :multiple-limit="2"
            >
              <el-option
                  v-for="item in showTextsListOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </div>
        </div>
        <div class="col-6" >
          <div class="my-3">
            <label class="me-3" for="textBoxPositionVertical">left 選擇垂直方向</label>
            <el-select v-model="duoVerticalValue" class="m-2" id="textBoxPositionVertical">
              <el-option
                  v-for="item in textBoxPositionVertical"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </div>
          <div class="my-3">
            <label class="me-3" for="textBoxPositionVertical">left 選擇文字方向</label>
            <el-select v-model="duoTextAlignmentValue" class="m-2" id="textBoxPositionVertical">
              <el-option
                  v-for="item in textAlignments"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </div>
          <div class="my-3">
            <label class="me-5">left Label 顏色</label>
            <el-color-picker color-format="rgb" v-model="duoLabelTextColor[0]" />
            <el-color-picker color-format="rgb" v-model="duoLabelTextColor[1]" />
            <el-color-picker color-format="rgb" v-model="duoLabelTextColor[2]" />
          </div>
        </div>
      </template>
      <template v-else-if="textModeValue === 'ThreeSensor'">
        <div class="col-6" >
          <div class="mx-4">
            <div class="me-3" >Controller選擇 (擇3)</div>
            <el-select
                v-model="controllerSelected"
                class="m-2"
                id="showTextsListOptionsWithThreeSensor"
                :multiple="true"
                :multiple-limit="3"
            >
              <el-option
                  v-for="item in showTextsListOptionsWithThreeSensor"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </div>
        </div>
        <div class="col-6" >
          <div class="my-3">
            <label class="me-5">Label 顏色</label>
            <el-color-picker color-format="rgb" v-model="threeLabelTextColor[0]" />
            <el-color-picker color-format="rgb" v-model="threeLabelTextColor[1]" />
          </div>
        </div>
      </template>
      <template v-else-if="textModeValue === 'FourSensor'">
        <div class="col-6" >
          <div class="mx-4">
            <div class="me-3" >Controller選擇 (擇4)</div>
            <el-select
                v-model="controllerSelected"
                class="m-2"
                id="showTextsListOptionsWithThreeSensor"
                :multiple="true"
                :multiple-limit="4"
            >
              <el-option
                  v-for="item in showTextsListOptionsWithThreeSensor"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </div>
        </div>
        <div class="col-6" >
          <div class="my-3">
            <label class="me-5">Label 顏色</label>
            <el-color-picker color-format="rgb" v-model="threeLabelTextColor[0]" />
            <el-color-picker color-format="rgb" v-model="threeLabelTextColor[1]" />
          </div>
        </div>
      </template>
      <template v-else-if="textModeValue === 'Custom'">
        <div class="col-6">
          <CustomTextInput
              v-model:custom-texts="customText"
              v-model:text-color="customLabelTextColor"
              v-model:text-fz="fontSize"
          />
        </div>
        <div class="col-6">
          <div class="my-3">
            <label class="me-3" for="textBoxPositionHorizontal">選擇水平方向</label>
            <el-select v-model="horizontalValue" class="m-2" id="textBoxPositionHorizontal">
              <el-option v-for="item in textBoxPositionHorizontal" :key="item.value" :label="item.label"
                         :value="item.value" />
            </el-select>
          </div>
          <div class="my-3">
            <label class="me-3" for="textBoxPositionVertical">選擇垂直方向</label>
            <el-select v-model="verticalValue" class="m-2" id="textBoxPositionVertical">
              <el-option v-for="item in textBoxPositionVertical" :key="item.value" :label="item.label"
                         :value="item.value" />
            </el-select>
          </div>
          <div class="my-3">
            <label class="me-3" for="textBoxPositionVertical">選擇文字方向</label>
            <el-select v-model="textAlignmentValue" class="m-2" id="textBoxPositionVertical">
              <el-option v-for="item in textAlignments" :key="item.value" :label="item.label"
                         :value="item.value" />
            </el-select>
          </div>
        </div>
      </template>
      <div class="col-6">
        <div>
          <label class="me-3" >文字陰影</label>
          <div class="d-flex">
            <el-slider v-model="textShadow" />
            <input class="w-25 ms-3" type="number" name="" id="" v-model="textShadow">
          </div>
        </div>
        <div>
          <label class="me-3">文字透明度</label>
          <div class="d-flex">
            <el-slider v-model="textOpacity" />
            <input class="w-25 ms-3" type="number" name="" id="" v-model="textOpacity">
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <WaterMarkImage
            v-model:water-mark-image-file-name="waterMarkImageFileName"
            v-model:wm-opacity="wmOpacity"
            v-model:wm-shadow="wmShadow"
            v-model:wm-horizontal="wmHorizontal"
            v-model:wm-vertical="wmVertical"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <button type="button" class="btn btn-primary mx-2" @click.stop="handleSubmit">確認</button>
        <button type="button" class="btn btn-secondary mx-2" @click.stop="handleInit">清空</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import CustomTextInput from '@/components/controllerMode/comp/TextInputComp.vue'
import WaterMarkImage from "@/components/controllerMode/comp/WaterMarkImageComp.vue";

import defaultValue from "@/utils/defaultValue"
import ColorTool from "@/utils/colorTool";
import freeImg from "@/utils/freeImg";

const {
  bgImages,
  watermarkImages
} = freeImg()

const {getRgbFilterString} = ColorTool()
const {
  showTextsList,
  showTextsListOptions,
  showTextsListOptionsWithThreeSensor,
  textModeIncludeDuo,
  textBoxPositionVertical,
  textBoxPositionHorizontal,
  textAlignments,
  fontFamilyVertical,
  fontFamilyVerticalWithSensor,
} = defaultValue()

const emit = defineEmits(['getTempControlData'])
const props = defineProps(['typeName'])
const tempControlData = reactive({
  Theme: {},
  Text: {},
  Watermark: {}
})

const imageFileName = ref('')
const bgColor = ref('rgb(0,0,0)')


//////文字控制/////

const fontFamily = ref('')
let fontSize = ref(43)

const controllerSelected = ref([]) // sensor
const controllerLoopSecond = ref(5) // 循環秒數

const textModeValue = ref('None')

// 垂直方向
const verticalValue = ref('Center')
const duoVerticalValue = ref('Center')

// 水平方向
const horizontalValue = ref('Center')

// 文字對齊
const textAlignmentValue = ref('Center')
const duoTextAlignmentValue = ref('Center')

const labelTextColor = ref(['rgb(130, 229, 245)', 'rgb(255, 255, 255)', 'rgb(131, 254, 234)'])
const duoLabelTextColor = ref(['rgb(130, 229, 245)', 'rgb(255, 255, 255)', 'rgb(131, 254, 234)'])
const threeLabelTextColor = ref(['rgb(255,255,255)', 'rgb(247, 255, 7)'])


const textOpacity = ref(100)
const textShadow = ref(35)

let customText = ref([])
let customLabelTextColor = ref(['rgb(130, 229, 245)'])

function handleChangeTextMode (item) {
  if (item === 'None') {
    // init
    fontFamily.value = ''
    controllerSelected.value = []
    controllerLoopSecond.value = 5
    verticalValue.value = 'Center'
    horizontalValue.value = 'Center'
    labelTextColor.value = ['rgb(130, 229, 245)', 'rgb(255, 255, 255)', 'rgb(131, 254, 234)']
  }
}

const limitCheckbox = () => {
  let maxNum = 4
  if (controllerSelected.value.length > maxNum) controllerSelected.value.splice(0, 1)
}

/////浮水印控制/////

const wmOpacity = ref(50)
const wmHorizontal = ref(50)
const wmVertical = ref(50)
const wmShadow = ref(50)

const waterMarkImageFileName = ref('')

function handleSubmit () {
  let BackgroundColor = []
  // 背景色
  if (bgColor.value.indexOf('rgb(') >= 0) BackgroundColor = getRgbFilterString(bgColor.value)

  Object.assign(tempControlData.Theme, {
    Type: props.typeName,
    Path: imageFileName.value,
    BackgroundColor
  })

  if (textModeValue.value === 'None') {
    Object.assign(tempControlData.Text, {
      Type: textModeValue.value
    })
  }
  else if (textModeValue.value === 'SliderSensor' || textModeValue.value === 'Time') {
    let FontColors = labelTextColor.value.map(item => getRgbFilterString(item))
    Object.assign(tempControlData.Text, {
      Type: textModeValue.value,
      Sensors: controllerSelected.value,
      LoopSecond: controllerLoopSecond.value,
      Layout: [
        {
          HorizontalAlignment: horizontalValue.value,
          VerticalAlignment: verticalValue.value,
          TextAlignment: textAlignmentValue.value,
          FontColors: FontColors,
          Shadow: textShadow.value,
          Opacity: textOpacity.value,
          FontFamily : fontFamily.value
        }
      ]
    })
  }
  else if (textModeValue.value === 'DuoSensor') {

    let duoFontColors = duoLabelTextColor.value.map(item => getRgbFilterString(item))

    Object.assign(tempControlData.Text, {
      Type: textModeValue.value,
      Sensors: controllerSelected.value,
      LoopSecond: controllerLoopSecond.value,
      Layout: [
        {
          HorizontalAlignment: 'Left',
          VerticalAlignment: duoVerticalValue.value,
          TextAlignment: duoTextAlignmentValue.value,
          FontColors: duoFontColors,
          Shadow: textShadow.value,
          Opacity: textOpacity.value,
          FontFamily : fontFamily.value
        },
        {
          HorizontalAlignment: 'Right',
          VerticalAlignment: duoVerticalValue.value,
          TextAlignment: duoTextAlignmentValue.value,
          FontColors: duoFontColors,
          Shadow: textShadow.value,
          Opacity: textOpacity.value,
          FontFamily : fontFamily.value
        }
      ]
    })
  }
  else if (textModeValue.value === 'ThreeSensor' || textModeValue.value === 'FourSensor') {

    let threeFontColors = threeLabelTextColor.value.map(item => getRgbFilterString(item))

    Object.assign(tempControlData.Text, {
      Type: textModeValue.value,
      Sensors: controllerSelected.value,
      Layout: [
        {
          FontColors: threeFontColors,
          Shadow: textShadow.value,
          FontFamily : fontFamily.value
        },
      ]
    })
  }
  else if (textModeValue.value === 'Custom') {

    let customLabelTextColors = customLabelTextColor.value.map(item => getRgbFilterString(item))

    Object.assign(tempControlData.Text, {
      Type: textModeValue.value,
      Text: customText.value,
      Layout: [
        {
          HorizontalAlignment: horizontalValue.value,
          VerticalAlignment: verticalValue.value,
          TextAlignment: textAlignmentValue.value,
          FontColors: customLabelTextColors,
          Shadow: textShadow.value,
          Opacity: textOpacity.value,
          FontFamily : fontFamily.value,
          FontSize: fontSize.value
        }
      ]
    })
  }


  // 浮水印
  Object.assign(tempControlData.Watermark, {
    "HasImage": waterMarkImageFileName.value !== '',
    "Image": waterMarkImageFileName.value !== '' ? waterMarkImageFileName.value : '',
    "Horizontal": wmHorizontal.value,
    "Vertical": wmVertical.value,
    "Shadow": wmShadow.value,
    "Opacity": wmOpacity.value
  })

  emit('getTempControlData', tempControlData)

}

function handleInit () {

}

</script>
